export default __webpack_public_path__ + "static/media/score-board-gif.dbb1f0f3.gif";